<div class="timeout-dialog" *ngIf="showTimeOutDialog">
  <div class="timeout-dialog__backdrop"></div>
  <div class="timeout-dialog__content">
    <div class="timeout-dialog__text">
      <h2>Bearbeitungszeit abgelaufen</h2>
      <p>
        Der Schutz Ihrer Daten ist uns wichtig! Daher sperren wir die
        Bearbeitung Ihres Antrags nach kurzer Zeit. Um Ihren Kreditantrag
        fortzusetzen, laden Sie die Seite neu und geben Sie anschließend Ihr
        Geburtsdatum ein.
      </p>
    </div>
    <div class="timeout-dialog__button">
      <button class="button-primary" (click)="closeDialog()">Ok</button>
    </div>
  </div>
</div>
